// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PIN1L","navList":"Footer_navList__QnsGK","navLink":"Footer_navLink__WNJ0N","copyright":"Footer_copyright__NnzfP"};